import React, { useRef } from 'react';
import colors from '../../../../../helpers/colors';
import { useFocus, useHover } from '../../../../../hooks/useElementState';
import {
  isTertiaryNavItemWithIcon,
  TertiaryNavItem,
  TertiaryNavItemWithIcon,
} from '../../../types';
import { NavItemWrapper, StyledTertiaryButtonWithMargin } from '../styles';
import { IconWithMargin, TertiaryButtonWithIcon } from './styles';

type TertiaryNavItemProps = {
  navItem: TertiaryNavItem | TertiaryNavItemWithIcon;
};

const TertiaryNavItemComponent: React.FC<TertiaryNavItemProps> = ({ navItem }) => {
  const ref = useRef<HTMLAnchorElement>(null);
  const isHovering = useHover(ref);
  const isFocused = useFocus(ref);

  return (
    <NavItemWrapper>
      {isTertiaryNavItemWithIcon(navItem) ? (
        <TertiaryButtonWithIcon
          href={navItem.url}
          onClick={navItem.onClick}
          target={navItem.openInNewTab ? '_blank' : undefined}
          referrerPolicy={
            (navItem?.customReferrerPolicy as React.HTMLAttributeReferrerPolicy) ||
            undefined
          }
          aria-label={navItem.screenReaderText}
          ref={ref}>
          {navItem.name}
          <IconWithMargin
            name={navItem.icon.name}
            size={navItem.icon.size ?? 'small'}
            color={colors.core01}
            displayVariant={!(isHovering || isFocused)}
          />
        </TertiaryButtonWithIcon>
      ) : (
        <StyledTertiaryButtonWithMargin
          href={navItem.url}
          onClick={navItem.onClick}
          openInNewTab={navItem.openInNewTab}
          screenReaderText={navItem.screenReaderText}>
          {navItem.name}
        </StyledTertiaryButtonWithMargin>
      )}
    </NavItemWrapper>
  );
};

export default TertiaryNavItemComponent;
